import classNames from "classnames";
import { useEffect, useState } from "react";

// use your local fallback image
import fallbackImg from "@/assets/logoo.png"; // or adjust path: ../../assets/nologo.png

const base_file_url =
  process.env.REACT_APP_BASE_FILE_URL || "https://4571901-sb1.app.netsuite.com";

export default function ProductImage({
  src,
  alt = "Product image",
  className = "",
  ...props
}) {
  // If src is absolute, use as-is; otherwise prepend base_file_url; if missing, use fallback
  const fullSrc = src
    ? /^https?:\/\//i.test(src)
      ? src
      : `${base_file_url}${src}`
    : fallbackImg;

  const [imgSrc, setImgSrc] = useState(fullSrc);

  useEffect(() => {
    setImgSrc(fullSrc);
  }, [fullSrc]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={classNames(className)}
      onError={() => setImgSrc(fallbackImg)} // swap to local image if load fails
      {...props}
    />
  );
}
